import { isValidEmail } from '@/mixins/regex.mixin'
import confirmDialogMixin from '@/mixins/cd.mixin.js'

import { logo } from '@/constants'
import fieldManagement from '@/constants/loginFieldObject'

import SosButton from '@/components/SosButton'
import SosLoginField from '@/components/SosLoginField'

import ModalTermsOfUse from '@/modals/ModalTermsOfUse'
import ConfirmDialog from '@/modals/ConfirmDialog'
import PasswordRecoveryModal from '@/modals/PasswordRecoveryModal'

import SosVersion from '@/components/SosVersion'

import { getDeviceForPing } from '@/functions/device'
import { apiCreateUser } from '@/services/users'
import { apiUserLogin } from '@/services/endpoints/session'

//
// COMPONENT
//

export default {
  name: 'Login',

  components: {
    'sos-button': SosButton,
    'sos-login-field': SosLoginField,

    'modal-terms-of-use': ModalTermsOfUse,
    'confirm-dialog': ConfirmDialog,
    'password-recovery-modal': PasswordRecoveryModal,

    'sos-version': SosVersion,
  },

  mixins: [
    confirmDialogMixin,
  ],

  data: () => ({
    logo,

    tab: 0,

    // SIGN IN FORM

    loadingSignIn: false,

    loginEmail: { ...fieldManagement, value: '' },
    loginPassword: { ...fieldManagement, value: '', hidden: true },

    // SIGN UP FORM

    loadingSignUp: false,

    nameSignUp: { ...fieldManagement, value: '' },
    telephoneSignUp: { ...fieldManagement, value: '' },
    emailSignUp: { ...fieldManagement, value: '' },
    emailConfirmationSignUp: { ...fieldManagement, value: '' },
    passwordSignUp: { ...fieldManagement, value: '' },
    passwordConfirmationSignUp: { ...fieldManagement, value: '' },
  }),

  mounted ()
  {
    //
    // SENHOR JESUS
    // Reseta status de carregamento dos grupos e usuários após logout (aplicar isso em outras telas públicas)
    //

    this.$store.dispatch('clearUserGroups', 'WAITING')
    this.$store.dispatch('clearUserManager', 'WAITING')

    // console.log('::: Login:', { loadingGroups: this.$store.state.app.loadingGroups, loadingUsers: this.$store.state.app.loadingUsers })
  },

  methods: {
    //
    //
    //
    // ?
    //
    //
    //

    //
    //
    //

    clearLoginEmail () {
      this.loginEmail.value = ''
    },

    clearLoginPassword () {
      this.loginPassword.value = ''
    },

    switchLoginPasswordMode () {
      this.loginPassword.hidden = !this.loginPassword.hidden
    },

    //
    //
    //

    clearRegisterName () {
      this.nameSignUp.value = ''
    },

    clearRegisterPhone () {
      this.telephoneSignUp.value = ''
    },

    clearRegisterEmail () {
      this.emailSignUp.value = ''
    },

    clearRegisterEmailConfirmation () {
      this.emailConfirmationSignUp.value = ''
    },

    clearRegisterPassword () {
      this.passwordSignUp.value = ''
    },

    clearRegisterPasswordConfirmation () {
      this.passwordConfirmationSignUp.value = ''
    },

    //
    //
    //
    // OPEN PASSWORD RECOVERY MODAL
    //
    //
    //

    openRecoveryWindow () {
      this.$refs.recoveryModal.open(this.loginEmail.value)
    },

    //
    //
    //
    // OPEN TERMS MODAL
    //
    //
    //

    openTermsModal () {
      this.$refs.termsModal.open()
    },

    //
    //
    //
    // SIGN IN FORM
    //
    //
    //

    async signIn ()
    {
      // CLEAN FIELDS STATUSES

      this.loginEmail.setError('')
      this.loginPassword.setError('')

      // VALIDATE

      const emailField = this.loginEmail.value.trim()
      const passwordField = this.loginPassword.value

      if (!isValidEmail(emailField)) {
        this.loginEmail.setError('Informe um e-mail válido.')
        this.$nextTick(() => { this.$refs.loginEmail.triggerBounce() })
      }

      if (passwordField.length < 6) {
        this.loginPassword.setError('Informe no mínimo 6 caracteres para a senha.')
        this.$nextTick(() => { this.$refs.loginPassword.triggerBounce() })
      }

      if (this.loginEmail.error || this.loginPassword.error)
      {
        if (this.loginEmail.error) {
          this.$refs.loginEmail.onFocus()
        } else if (this.loginPassword.error) {
          this.$refs.loginPassword.onFocus()
        }

        return false
      }

      // RUN

      this.loadingSignIn = true

      const device = await getDeviceForPing()
      const response = await apiUserLogin(device, emailField, passwordField)

      if (response.httpCode !== 200)
      {
        this.loadingSignIn = false

        const target = String(response?.data?.target || '').trim()

        if (target === 'PASSWORD') {
          this.loginPassword.setError(response.message)
        } else if (target === 'EMAIL') {
          this.loginEmail.setError(response.message)
        } else {
          this.loginEmail.setError('')
          this.loginPassword.setError('')
        }

        this.showDialog(response.title, response.message, 'signin', target, true, 'right', 330, true)
      }
    },

    //
    //
    //
    // SIGN UP FORM
    //
    //
    //

    async signUp ()
    {
      // CLEAN FIELDS STATUSES

      this.nameSignUp.setError('')
      this.telephoneSignUp.setError('')
      this.emailSignUp.setError('')
      this.emailConfirmationSignUp.setError('')
      this.passwordSignUp.setError('')
      this.passwordConfirmationSignUp.setError('')

      // VALIDATE

      const nome = this.nameSignUp.value.trim()
      const telefone = this.telephoneSignUp.value.replace(/[^0-9]/g, '')
      const email = this.emailSignUp.value.trim()
      const emailConfirmation = this.emailConfirmationSignUp.value.trim()
      const password = this.passwordSignUp.value.trim()
      const passwordConfirmation = this.passwordConfirmationSignUp.value.trim()

      if (nome.length < 3 || nome.length > 64) {
        this.nameSignUp.setError('Digite entre 3 e 64 caracteres')
        this.$nextTick(() => { this.$refs.nameSignUp.triggerBounce() })
      }

      if (telefone.length < 10 || telefone.length > 11) {
        this.telephoneSignUp.setError('Digite um número nos formatos: (99) 91234-5678 ou (99) 1234-5678')
        this.$nextTick(() => { this.$refs.telephoneSignUp.triggerBounce() })
      }

      if (!isValidEmail(email)) {
        this.emailSignUp.setError('E-mail inválido')
        this.$nextTick(() => { this.$refs.emailSignUp.triggerBounce() })
      }

      if (email !== emailConfirmation) {
        this.emailConfirmationSignUp.setError('E-mail e confirmação de e-mail não conferem')
        this.$nextTick(() => { this.$refs.emailConfirmationSignUp.triggerBounce() })
      }

      if (password.length < 8 || password.length > 20 || password.search(/\d/) === -1 || password.search(/[a-zA-Z]/) === -1) {
        this.passwordSignUp.setError('Digite entre 8 e 20 caracteres contendo letras e números')
        this.$nextTick(() => { this.$refs.passwordSignUp.triggerBounce() })
      }

      if (passwordConfirmation !== password) {
        this.passwordConfirmationSignUp.setError('Senha e confirmação de senha não conferem')
        this.$nextTick(() => { this.$refs.passwordConfirmationSignUp.triggerBounce() })
      }

      if (
        this.nameSignUp.error ||
        this.telephoneSignUp.error ||
        this.emailSignUp.error ||
        this.emailConfirmationSignUp.error ||
        this.passwordSignUp.error ||
        this.passwordConfirmationSignUp.error
      ) {
        if (this.nameSignUp.error) {
          this.$refs.nameSignUp.onFocus()
        } else if (this.telephoneSignUp.error) {
          this.$refs.telephoneSignUp.onFocus()
        } else if (this.emailSignUp.error) {
          this.$refs.emailSignUp.onFocus()
        } else if (this.emailConfirmationSignUp.error) {
          this.$refs.emailConfirmationSignUp.onFocus()
        } else if (this.passwordSignUp.error) {
          this.$refs.passwordSignUp.onFocus()
        } else if (this.passwordConfirmationSignUp.error) {
          this.$refs.passwordConfirmationSignUp.onFocus()
        }

        return false
      }

      // RUN

      this.loadingSignUp = true
      const request = await apiCreateUser({ origin: 'WEB', name: nome, email, password, phone: telefone, crm: '', groupID: '' })
      this.loadingSignUp = false

      // SHOW BACK-END RESPONSE
      this.showMessage(request.title, request.message)

      // REGISTER WAS SUCCESSFULL
      if (request.httpCode === 201)
      {
        // ENTRAR NO FORMULÁRIO DE ACESSO
        this.tab = 0

        // INCLUIR E-MAIL E SENHA RECÉM CRIADOS NO FORMULÁRIO DE ACESSO
        this.loginEmail.value = email
        this.loginPassword.value = password

        this.loginEmail.setError('')
        this.loginPassword.setError('')
      }
    },

    //
    //
    //
    //
    //
    //
    //

    cdAction (cdResponse)
    {
      // console.log('::: cdAction:', cdResponse)

      if (cdResponse.cdType === 'signin')
      {
        if (cdResponse.cdData === 'PASSWORD') {
          this.$nextTick(() => { this.$refs.loginPassword.onFocus() })
        } else {
          this.$nextTick(() => { this.$refs.loginEmail.onFocus() })
        }
      }
    },
  },
}
